import { createContext, useContext, useRef, useState } from 'react'
import moment from 'moment'
import { useLocation } from 'react-router-dom'

const NoticesContext = createContext([])

export const useNoticesContext = () => {
    return useContext(NoticesContext)
}

export const NoticesProvider = ({ children }) => {
    const [last, setLast] = useState(0)
    const [notices, setNotices] = useState([])
    const noticesRef = useRef(null)

    const location = useLocation()

    // Imperative, opt-in scroll — used only by the document editor after a save,
    // never automatically (the entry page, for one, must stay scrollable).
    const scrollToNotices = () => {
        requestAnimationFrame(() => {
            noticesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
    }

    const addNotices = ({
        notices: noticesItemOrArray,
        clear,
    }) => {
        const notices = Array.isArray(noticesItemOrArray) ? noticesItemOrArray : [noticesItemOrArray]

        const now = moment()

        let index = last

        const newNotices =
            notices.map((notice) => ({
                type: 'info',
                ...notice,
                id: ++index,
                route: location.pathname,
                time: now.format('HH:mm:ss'),
            }))
        setLast(index)
        setNotices((previousNotices) =>
            clear
                ? [...newNotices]
                : [...previousNotices, ...newNotices],
        )
    }

    const removeNotices = (idsItemOrArray) => {
        const ids = Array.isArray(idsItemOrArray) ? idsItemOrArray : [idsItemOrArray]

        setNotices((previousNotices) =>
            previousNotices.filter((notice) => !ids.includes(notice.id)),
        )
    }

    const clearNotices = () => {
        setNotices([])
    }

    return (
        <NoticesContext.Provider value={{ notices, noticesRef, addNotices, removeNotices, clearNotices, scrollToNotices }}>
            {children}
        </NoticesContext.Provider>
    )
}
